import {
	CardContent,
	Expandable,
	FormControlLabel,
	Pill,
	RadioButton,
	Stack,
	Text,
	useText,
} from "@sveabank/cc-common";
import { Images } from "../../../../images";
import type { ClcPackage } from "../../../../types/package";
import ClcForetagarnaInfoBlock from "./clc-foretagarna-info-block";
import useClcSelectPackage from "./hooks/useClcSelectPackage";

type Props = {
	foretagarnaPackage?: ClcPackage;
	basePackageId: string;
	selectedPackageId?: string;
	onOptimisticSelect: (packageId?: string) => void;
};

const ClcForetagarnaOfferBlock = ({
	foretagarnaPackage,
	basePackageId,
	selectedPackageId,
	onOptimisticSelect,
}: Props) => {
	const [t, texts] = useText();
	const { selectPackage, isSelectingPackage } = useClcSelectPackage();

	if (!foretagarnaPackage) return null;

	const isForetagarnaSelected = selectedPackageId === foretagarnaPackage.packageId;

	const onSelect = (packageId: string) => {
		if (!packageId || isSelectingPackage) return;

		onOptimisticSelect(packageId);
		void selectPackage(packageId).catch(() => onOptimisticSelect(undefined));
	};
	const packages = texts.newCompany.packages;
	const text = packages["FÖRETAGARNA-SVEA-STARTA-BOLAG"];

	return (
		<CardContent>
			<div className="rounded-sm bg-[#F8F8F8] p-4">
				<Stack gap={4}>
					<Stack gap={2} justify="between" direction="row">
						<img
							src={Images.FORETAGARNA_LOGO}
							alt={t(text.logoAlt)}
							className="max-w-24 md:max-w-none"
						/>
						<Pill text={t(text.offer.label)} status="success" size="sm" />
					</Stack>

					<Text bold>{t(text.offer.question)}</Text>

					<Stack gap={isForetagarnaSelected ? 8 : 1}>
						<FormControlLabel label={t(text.offer.yesOption)}>
							<RadioButton
								name="foretagarna-offer"
								value={foretagarnaPackage.packageId}
								onChange={() => onSelect(foretagarnaPackage.packageId)}
								checked={isForetagarnaSelected}
							/>
						</FormControlLabel>

						<Expandable
							isExpanded={isForetagarnaSelected}
							headingId="foretagarna-offer-heading"
							contentId="foretagarna-offer-content"
							speed="fast"
						>
							<ClcForetagarnaInfoBlock />
						</Expandable>

						<FormControlLabel label={t(text.offer.noOption)}>
							<RadioButton
								name="foretagarna-offer"
								value={basePackageId}
								onChange={() => onSelect(basePackageId)}
								checked={!isForetagarnaSelected}
							/>
						</FormControlLabel>
					</Stack>
				</Stack>
			</div>
		</CardContent>
	);
};

export default ClcForetagarnaOfferBlock;
